import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LayoutPageTabs, TabConfig } from '@/components/layouts/LayoutPageTabs';
import { Radar, Users } from 'lucide-react';
import { HubAdminMember } from './HubAdminMember';
import { AdminMissionControl } from '@/pages/admin/AdminMissionControl';

const VALID_SECTIONS = ['members', 'mission-control'] as const;
type Section = typeof VALID_SECTIONS[number];

function isValidSection(s: string): s is Section {
  return VALID_SECTIONS.includes(s as Section);
}

export function HubAdmin() {
  const navigate = useNavigate();
  const { section } = useParams<{ section?: string }>();
  const currentSection = section && isValidSection(section) ? section : 'members';

  useEffect(() => {
    if (!section || !isValidSection(section)) {
      navigate('/admin/members', { replace: true });
    }
  }, [section, navigate]);

  const tabs: TabConfig[] = [
    { id: 'members', label: 'Members', icon: Users, content: <HubAdminMember /> },
    { id: 'mission-control', label: 'Mission Control', icon: Radar, content: <AdminMissionControl /> },
  ];

  return (
    <div className="space-y-4">
      <LayoutPageTabs
        tabs={tabs}
        defaultTab={currentSection}
        onTabChange={(tabId) => navigate(`/admin/${tabId}`)}
      />
    </div>
  );
}
